/* Version 2026-10-12b */
/* kaufdeinkabel.de – Gerätefinder und Kompatibilität
 * Lädt Geräte und Produktdaten aus /collections/all?view=kdk-daten, merkt sich das gewählte Gerät
 * und bewertet jedes Produkt: passt / pruefen / nicht. Ohne JavaScript bleibt der Shop voll nutzbar.
 */
(function () {
  'use strict';

  var SPEICHER_GERAET = 'kdk-geraet';
  var SPEICHER_DATEN = 'kdk-daten-v2';
  var DATEN_MAX_ALTER = 30 * 60 * 1000;
  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  var TYPEN = [
    { id: 'netzteil', name: 'Netzteile & Ladegeräte', kurz: 'Netzteil / Ladegerät', typen: ['Netzteil'] },
    { id: 'kabel', name: 'Ladekabel', kurz: 'Ladekabel', typen: ['Ladekabel', 'Adapter'] },
    { id: 'huelle', name: 'Hüllen', kurz: 'Hülle', typen: ['Hülle'] },
    { id: 'kabellos', name: 'Kabellos laden', kurz: 'Kabelloses Ladegerät', typen: ['Kabelloses Ladegerät'] },
    { id: 'auto', name: 'Laden im Auto', kurz: 'Kfz-Ladegerät', typen: ['Kfz-Ladegerät'] },
    { id: 'zubehoer', name: 'Zubehör', kurz: 'Zubehör', typen: ['Handyhalter'] }
  ];

  // ------------------------------------------------------------ Speicher
  function lies(k) { try { return window.localStorage.getItem(k); } catch (e) { return null; } }
  function schreib(k, v) { try { if (v == null) window.localStorage.removeItem(k); else window.localStorage.setItem(k, v); } catch (e) { /* privat */ } }

  // ------------------------------------------------------------ Daten
  var datenPromise = null;
  function ladeDaten() {
    if (datenPromise) return datenPromise;
    try {
      var c = JSON.parse(window.sessionStorage.getItem(SPEICHER_DATEN) || 'null');
      if (c && Date.now() - c.zeit < DATEN_MAX_ALTER) { datenPromise = Promise.resolve(aufbereiten(c.d)); return datenPromise; }
    } catch (e) { /* ignorieren */ }
    var url = function (n) { return ROOT + 'collections/all?view=kdk-daten&page=' + n; };
    var geraeteP = fetch(ROOT + 'collections/all?view=kdk-geraete', { credentials: 'same-origin' }).then(function (r) { return r.json(); });
    datenPromise = Promise.all([fetch(url(1), { credentials: 'same-origin' }).then(function (r) { return r.json(); }), geraeteP])
      .then(function (paar) {
        var erste = paar[0];
        erste.geraete = paar[1].geraete;
        var rest = [];
        for (var n = 2; n <= (erste.seiten || 1); n++) rest.push(fetch(url(n)).then(function (r) { return r.json(); }));
        return Promise.all(rest).then(function (seiten) {
          var d = { geraete: erste.geraete || [], produkte: erste.produkte || [] };
          seiten.forEach(function (s) { d.produkte = d.produkte.concat(s.produkte || []); });
          try { window.sessionStorage.setItem(SPEICHER_DATEN, JSON.stringify({ zeit: Date.now(), d: d })); } catch (e) { /* voll */ }
          return aufbereiten(d);
        });
      })
      .catch(function () { return aufbereiten({ geraete: [], produkte: [] }); });
    return datenPromise;
  }

  function aufbereiten(d) {
    var geraete = (d.geraete || []).slice().sort(function (x, y) {
      return x.m === y.m ? (y.j - x.j) || ((x.o || 9999) - (y.o || 9999)) || x.n.localeCompare(y.n, 'de', { numeric: true }) : x.m.localeCompare(y.m);
    });
    var gIndex = {}, pIndex = {};
    geraete.forEach(function (g) { gIndex[g.h] = g; });
    d.produkte.forEach(function (p) { pIndex[p.h] = p; });
    return { geraete: geraete, gIndex: gIndex, produkte: d.produkte, pIndex: pIndex };
  }

  // ------------------------------------------------------------ Bewertung
  function bewerteLang(p, g) {
    if (!p || !g || !p.typ) return null;
    var name = g.n;
    switch (p.typ) {
      case 'Hülle':
      case 'Hülle + Schutzglas':
      case 'Schutzfolie':
      case 'Handyhalter':
        if (!p.g || !p.g.length) return null;
        return p.g.indexOf(g.h) > -1
          ? { s: 'passt', text: 'Passt zu deinem ' + name }
          : { s: 'nicht', text: 'Passt nicht zu ' + name };

      case 'Ladekabel':
        if (!p.b) return null;
        // Anschluss B ist die Geräte-Seite, Anschluss A die Netzteil-Seite
        if (p.b !== g.a) {
          return { s: 'nicht', text: 'Falscher Stecker – dein ' + name + ' braucht ' + g.a, braucht: g.a };
        }
        var andere = p.a;
        if (andere === 'USB-A' && g.w >= 20) return { s: 'pruefen', text: 'Lädt, aber ohne Schnellladen (USB-A)' };
        if (p.w && p.w < g.w * 0.75) return { s: 'pruefen', text: 'Lädt mit max. ' + p.w + ' W statt ' + g.w + ' W' };
        return { s: 'passt', text: 'Passt zu deinem ' + name };

      case 'Adapter':
        if (!p.b) return null;
        return p.b === g.a ? { s: 'passt', text: 'Passt zu deinem ' + name } : { s: 'nicht', text: 'Passt nicht zu ' + name };

      case 'Netzteil':
      case 'Kfz-Ladegerät':
        var ports = p.aus || [];
        var port = ports.indexOf('USB-C') > -1 && g.a !== 'Micro-USB' ? 'USB-C' : (ports[0] || 'USB-C');
        if (p.kd && p.b && p.b !== g.a) {
          return { s: 'pruefen', text: 'Beiliegendes Kabel passt nicht – du brauchst ' + port + ' auf ' + g.a, kabel: { a: port, b: g.a } };
        }
        var hinweisKabel = p.kd ? null : { a: port, b: g.a };
        if (g.a === 'Micro-USB' && ports.indexOf('USB-A') < 0) {
          return { s: 'pruefen', text: 'Nur mit Kabel USB-C auf Micro-USB', kabel: hinweisKabel };
        }
        if (ports.indexOf('USB-C') < 0 && g.w >= 20) {
          return { s: 'pruefen', text: 'Lädt, aber ohne Schnellladen (USB-A)', kabel: hinweisKabel };
        }
        // Schnellladen ab 20 W bzw. ab der Maximalleistung kleinerer Geräte
        var schnell = Math.min(g.w || 20, 20);
        if (p.w && p.w < schnell) {
          return { s: 'pruefen', text: 'Lädt, aber langsamer (' + p.w + ' W)', kabel: hinweisKabel };
        }
        return { s: 'passt', text: p.w >= g.w ? 'Lädt dein ' + name + ' mit voller Geschwindigkeit' : 'Lädt dein ' + name + ' schnell (' + p.w + ' W)', kabel: hinweisKabel };

      case 'Kabelloses Ladegerät':
        if (!g.k) return { s: 'nicht', text: 'Dein ' + name + ' kann nicht kabellos laden' };
        if (/magsafe/i.test(p.t) && !g.ms) return { s: 'pruefen', text: 'Lädt, hält aber nicht magnetisch' };
        return { s: 'passt', text: 'Passt zu deinem ' + name };
    }
    return null;
  }

  function bewerte(p, g) {
    var b = bewerteLang(p, g);
    if (!b) return null;
    var n = g.n;
    b.kurz = b.text.replace('Passt zu deinem ' + n, 'Passt').replace('Passt nicht zu ' + n, 'Passt nicht')
      .replace(' – dein ' + n + ' braucht', ' – braucht').replace('Lädt dein ' + n + ' ', 'Lädt ').replace('Dein ' + n + ' kann', 'Kann');
    return b;
  }
  function chipKurz(b) { return chipHtml({ s: b.s, text: b.kurz || b.text }); }

  // Bestes passendes Kabel für einen Kabelbedarf {a, b}
  function passendesKabel(daten, bedarf, g) {
    if (!bedarf) return null;
    var k = daten.produkte.filter(function (p) {
      return p.ok && p.typ === 'Ladekabel' && ((p.a === bedarf.a && p.b === bedarf.b) || (p.a === bedarf.b && p.b === bedarf.a));
    });
    k.sort(function (x, y) { return (y.o - x.o) || (x.p - y.p); });
    return k[0] || null;
  }

  function variantFuer(p, g) {
    if (!p.vg || !g) return p.var;
    for (var id in p.vg) { if (p.vg[id].indexOf(g.h) > -1) return Number(id); }
    return p.var;
  }

  // ------------------------------------------------------------ Gerät merken
  function aktuellesGeraet(daten) {
    var seite = document.querySelector('[data-kdk-seiten-geraet]');
    var url = new URLSearchParams(window.location.search).get('geraet') || (seite && seite.getAttribute('data-kdk-seiten-geraet'));
    if (url && daten.gIndex[url]) { schreib(SPEICHER_GERAET, url); return daten.gIndex[url]; }
    var h = lies(SPEICHER_GERAET);
    return h && daten.gIndex[h] ? daten.gIndex[h] : null;
  }
  function setzeGeraet(h, navigiert) {
    schreib(SPEICHER_GERAET, h || null);
    document.dispatchEvent(new CustomEvent('kdk:geraet', { detail: { handle: h, navigiert: !!navigiert } }));
  }

  // ------------------------------------------------------------ Darstellung
  var ICON = {
    passt: '<svg viewBox="0 0 24 24" aria-hidden="true"><circle cx="12" cy="12" r="9"/><path d="M8 12.5l2.7 2.7L16 9.8"/></svg>',
    pruefen: '<svg viewBox="0 0 24 24" aria-hidden="true"><circle cx="12" cy="12" r="9"/><path d="M12 7.5v5.5M12 16.5v.1"/></svg>',
    nicht: '<svg viewBox="0 0 24 24" aria-hidden="true"><circle cx="12" cy="12" r="9"/><path d="M9 9l6 6M15 9l-6 6"/></svg>'
  };
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function chipHtml(b) { return '<span class="kdk-chip kdk-chip--' + b.s + '">' + ICON[b.s] + '<span>' + esc(b.text) + '</span></span>'; }
  function preis(cent) {
    return (cent / 100).toLocaleString('de-DE', { style: 'currency', currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR' });
  }
  function technik(p) {
    var t = [];
    if ((p.typ === 'Ladekabel' || p.typ === 'Adapter') && p.a) t.push(p.a + ' → ' + p.b);
    if ((p.typ === 'Netzteil' || p.typ === 'Kfz-Ladegerät') && p.aus) t.push(p.aus.join(' + '));
    if (p.w) t.push(p.w + ' W');
    if (p.l) t.push(String(p.l).replace('.', ',') + ' m');
    if (p.kd) t.push('inkl. Kabel');
    return t.join(' · ');
  }
  var RANG = { passt: 0, pruefen: 1, nicht: 2 };
  var LADE = ['Netzteil', 'Kfz-Ladegerät', 'Kabelloses Ladegerät', 'Ladekabel', 'Adapter'];

  // Badges der Mengenrabatt-App (Qikify) auf Deutsch
  function appBadgesDeutsch(wurzel) {
    (wurzel || document).querySelectorAll('.qvl-volume-discount-badge-wrapper, .qvl-volume-discount-badge-wrapper *').forEach(function (el) {
      if (el.children.length) return;
      var m = /up\s*to\s*(\d+)\s*%\s*off/i.exec(el.textContent);
      if (m) el.textContent = 'Mengenrabatt bis −' + m[1] + ' %';
      else if (/^\s*(\d+)\s*%\s*off\s*$/i.test(el.textContent)) el.textContent = 'Mengenrabatt −' + el.textContent.match(/\d+/)[0] + ' %';
    });
  }

  // Chips auf Produktkarten (Dawn-Raster, Bestseller usw.)
  function chipsAufKarten(daten, g) {
    document.querySelectorAll('[data-kdk-handle]').forEach(function (karte) {
      var slot = karte.querySelector('.kdk-card-slot');
      if (!slot) return;
      var b = g && bewerte(daten.pIndex[karte.getAttribute('data-kdk-handle')], g);
      var html = b ? chipKurz(b) : '';
      if (slot.innerHTML !== html) slot.innerHTML = html;
      if (karte.getAttribute('data-kdk-status') !== (b ? b.s : '')) karte.setAttribute('data-kdk-status', b ? b.s : '');
    });
    var raster = document.querySelector('#product-grid');
    var leiste = document.querySelector('[data-kdk-filterleiste]');
    if (raster && leiste) {
      var anzahl = raster.querySelectorAll('[data-kdk-status="nicht"]').length;
      leiste.hidden = !g || !anzahl;
      if (g) leiste.querySelector('[data-kdk-filter-text]').textContent = anzahl + ' Produkte auf dieser Seite passen nicht zu deinem ' + g.n + '.';
      var aus = leiste.querySelector('input');
      raster.classList.toggle('kdk-nur-passende', !!(aus && aus.checked));
    }
  }

  // Auswahlfelder füllen: Hersteller → Modell
  function fuelleAuswahl(form, daten, g) {
    var hs = form.querySelector('[name="hersteller"]');
    var mo = form.querySelector('[name="geraet"]');
    if (!hs || !mo) return;
    var marken = [];
    daten.geraete.forEach(function (x) { if (marken.indexOf(x.m) < 0) marken.push(x.m); });
    hs.innerHTML = '<option value="">Hersteller wählen</option>' + marken.map(function (m) { return '<option>' + esc(m) + '</option>'; }).join('');
    function modelle() {
      var m = hs.value;
      var gruppen = {}, reihenfolge = [];
      daten.geraete.filter(function (x) { return x.m === m; }).forEach(function (x) {
        if (!gruppen[x.s]) { gruppen[x.s] = []; reihenfolge.push(x.s); }
        gruppen[x.s].push(x);
      });
      mo.innerHTML = '<option value="">' + (m ? 'Modell wählen' : 'Erst Hersteller wählen') + '</option>' + reihenfolge.map(function (s) {
        return '<optgroup label="' + esc(s) + '">' + gruppen[s].map(function (x) { return '<option value="' + esc(x.h) + '">' + esc(x.n) + '</option>'; }).join('') + '</optgroup>';
      }).join('');
      mo.disabled = !m;
    }
    hs.addEventListener('change', function () { modelle(); aktualisiereFinder(form, daten); });
    mo.addEventListener('change', function () { aktualisiereFinder(form, daten); });
    var typ = form.querySelector('[name="typ"]');
    var typUrl = new URLSearchParams(window.location.search).get('typ');
    if (typ && typUrl && typ.querySelector('option[value="' + typUrl + '"]')) typ.value = typUrl;
    if (typ) typ.addEventListener('change', function () { aktualisiereFinder(form, daten); });
    if (g) { hs.value = g.m; modelle(); mo.value = g.h; } else { modelle(); }
    aktualisiereFinder(form, daten);
  }

  function treffer(daten, g, typId) {
    var def = TYPEN.filter(function (t) { return t.id === typId; })[0];
    return daten.produkte.map(function (p) {
      if (!p.ok) return null; // Ausverkauftes nicht im Finder zeigen
      if (def && def.typen.indexOf(p.typ) < 0) return null;
      var b = bewerte(p, g);
      return b && b.s !== 'nicht' ? { p: p, b: b } : null;
    }).filter(Boolean);
  }

  function aktualisiereFinder(form, daten) {
    var g = daten.gIndex[form.querySelector('[name="geraet"]').value];
    var typ = form.querySelector('[name="typ"]');
    var knopf = form.querySelector('[type="submit"]');
    var info = form.querySelector('[data-kdk-finder-info]');
    if (!g) {
      knopf.disabled = true;
      knopf.textContent = 'Passendes Zubehör zeigen';
      if (info) info.innerHTML = '';
      return;
    }
    var n = treffer(daten, g, typ ? typ.value : '').length;
    if (form.hasAttribute('data-kdk-nur-merken')) { knopf.disabled = false; knopf.textContent = g.n + ' merken'; }
    else { knopf.disabled = n === 0; knopf.textContent = n === 1 ? '1 passendes Produkt zeigen' : n + ' passende Produkte zeigen'; }
    if (info) {
      info.innerHTML = '<span class="kdk-chip kdk-chip--passt">' + ICON.passt + '<span>Anschluss: ' + esc(g.a) + '</span></span>' +
        (g.w >= 20 ? '<span class="kdk-chip kdk-chip--passt">' + ICON.passt + '<span>Schnellladen per USB-C</span></span>' : '') +
        (g.k ? '<span class="kdk-chip kdk-chip--passt">' + ICON.passt + '<span>' + (g.ms ? 'MagSafe / kabellos' : 'Kabellos laden') + '</span></span>' : '');
    }
  }

  function initFinder(daten, g) {
    document.querySelectorAll('form[data-kdk-finder]').forEach(function (form) {
      if (form.dataset.kdkBereit) return;
      form.dataset.kdkBereit = '1';
      fuelleAuswahl(form, daten, g);
      form.addEventListener('submit', function (e) {
        var h = form.querySelector('[name="geraet"]').value;
        if (form.hasAttribute('data-kdk-nur-merken')) {
          e.preventDefault();
          var dlg = form.closest('dialog');
          if (dlg) dlg.close();
          if (h) setzeGeraet(h);
          return;
        }
        if (h) setzeGeraet(h);
        var hs = form.querySelector('[name="hersteller"]');
        if (hs) hs.disabled = true; // nicht in die URL
      });
    });
  }

  // Ergebnisseite /collections/all?view=finder&geraet=…&typ=…
  function initErgebnis(daten, g) {
    var wurzel = document.querySelector('[data-kdk-ergebnis]');
    if (!wurzel) return;
    var param = new URLSearchParams(window.location.search);
    var typId = param.get('typ') || '';
    var titel = wurzel.querySelector('[data-kdk-ergebnis-titel]');
    var ziel = wurzel.querySelector('[data-kdk-ergebnis-liste]');
    var reiter = wurzel.querySelector('[data-kdk-reiter]');
    if (!g) {
      titel.textContent = 'Wähle dein Gerät';
      ziel.innerHTML = '<p class="kdk-leer">Wähle oben Hersteller und Modell, dann zeigen wir dir alles, was passt.</p>';
      return;
    }
    titel.textContent = 'Zubehör für dein ' + g.n;
    var aendern = wurzel.querySelector('[data-kdk-ergebnis-aendern]');
    if (aendern) aendern.open = false;
    var alle = treffer(daten, g, '');
    reiter.innerHTML = [{ id: '', name: 'Alles' }].concat(TYPEN).map(function (t) {
      var n = t.id ? alle.filter(function (x) { return t.typen.indexOf(x.p.typ) > -1; }).length : alle.length;
      if (!n && t.id) return '';
      var url = '?view=finder&geraet=' + encodeURIComponent(g.h) + (t.id ? '&typ=' + t.id : '');
      return '<a class="kdk-chip kdk-chip--filter" href="' + url + '"' + (t.id === typId ? ' aria-current="page"' : '') + '>' + esc(t.name) + ' <span class="kdk-anzahl">' + n + '</span></a>';
    }).join('');

    var gruppen = typId ? TYPEN.filter(function (t) { return t.id === typId; }) : TYPEN;
    var html = gruppen.map(function (t) {
      var liste = treffer(daten, g, t.id);
      if (!liste.length) return '';
      liste.sort(function (x, y) {
        return (RANG[x.b.s] - RANG[y.b.s]) || (y.p.ok - x.p.ok) || (y.p.o - x.p.o) || (x.p.p - y.p.p);
      });
      return '<section class="kdk-gruppe"><h2 class="kdk-gruppe__titel">' + esc(t.name) + ' <span class="kdk-anzahl">' + liste.length + '</span></h2>' +
        '<ul class="kdk-raster" role="list">' + liste.map(function (x) { return '<li>' + karteHtml(x.p, x.b, g, daten) + '</li>'; }).join('') + '</ul></section>';
    }).join('');
    ziel.innerHTML = html || '<p class="kdk-leer">Für dein ' + esc(g.n) + ' haben wir in diesem Bereich gerade nichts. Schreib uns – wir besorgen es gern.</p>';
  }

  function karteHtml(p, b, g, daten) {
    var vid = variantFuer(p, g);
    var url = p.u + (vid ? '?variant=' + vid : '');
    var kabel = b && b.kabel && passendesKabel(daten, b.kabel, g);
    return '<article class="kdk-karte">' +
      '<a class="kdk-karte__bild" href="' + esc(url) + '" tabindex="-1" aria-hidden="true">' +
      (p.img ? '<img src="' + esc(p.img) + '" alt="" loading="lazy" width="400" height="400">' : '') +
      '<span class="kdk-karte__badges">' + (p.o ? '<span class="kdk-badge kdk-badge--gruen">Original</span>' : (LADE.indexOf(p.typ) > -1 ? '<span class="kdk-badge kdk-badge--tipp">Preis-Tipp</span>' : '')) +
      (p.cp > p.p ? '<span class="kdk-badge kdk-badge--aktion">−' + Math.round((1 - p.p / p.cp) * 100) + ' %</span>' : '') +
      (!p.ok ? '<span class="kdk-badge kdk-badge--aus">Ausverkauft</span>' : '') + '</span></a>' +
      '<div class="kdk-karte__text">' +
      '<span class="kdk-label kdk-gedaempft">' + esc(p.v) + '</span>' +
      '<h3 class="kdk-karte__titel"><a href="' + esc(url) + '">' + esc(p.t) + '</a></h3>' +
      (technik(p) ? '<p class="kdk-technik">' + esc(technik(p)) + '</p>' : '') +
      (b ? chipKurz(b) : '') +
      (b && b.kabel ? '<p class="kdk-karte__hinweis">Kabel nötig: ' + esc(b.kabel.a) + ' auf ' + esc(b.kabel.b) +
        (kabel ? ' – <a href="' + esc(kabel.u) + '">passendes Kabel ab ' + preis(kabel.p) + '</a>' : '') + '</p>' : '') +
      '<p class="kdk-karte__preis">' + (p.pv ? 'ab ' : '') + preis(p.p) + (p.cp > p.p ? ' <s>' + preis(p.cp) + '</s>' : '') + '</p>' +
      (p.ok ? '<form method="post" action="' + ROOT + 'cart/add"><input type="hidden" name="id" value="' + vid + '"><input type="hidden" name="quantity" value="1">' +
        '<button class="kdk-btn kdk-btn--primaer kdk-btn--voll" type="submit">In den Warenkorb</button></form>' : '') +
      '</div></article>';
  }

  // Produktseite: Passung + „Dazu passend“
  function initProdukt(daten, g) {
    document.querySelectorAll('[data-kdk-produkt]').forEach(function (el) {
      var p = daten.pIndex[el.getAttribute('data-kdk-produkt')];
      var ziel = el.querySelector('[data-kdk-passung]');
      if (!p || !ziel) return;
      if (!g) {
        ziel.innerHTML = p.typ && p.typ !== 'Sonstiges'
          ? '<p class="kdk-passung__frage">Passt das zu deinem Gerät? <button type="button" class="kdk-btn kdk-btn--text" data-kdk-aendern-global>Gerät wählen</button></p>' : '';
      } else {
        var b = bewerte(p, g);
        var zusatz = '';
        if (b && b.kabel) {
          var k = passendesKabel(daten, b.kabel, g);
          zusatz = '<p class="kdk-karte__hinweis">Dazu brauchst du ein Kabel ' + esc(b.kabel.a) + ' auf ' + esc(b.kabel.b) + '.' +
            (k ? ' <a href="' + esc(k.u) + '">' + esc(k.t) + ' – ' + preis(k.p) + '</a>' : '') + '</p>';
        }
        var nk = nachKauf();
        var alt = nk && nk.querySelector('.kdk-nach-kauf__alternativen');
        if (alt) alt.remove();
        if (b && b.s === 'nicht' && nk) {
          nk.insertAdjacentHTML('afterbegin', '<p class="kdk-nach-kauf__alternativen"><a class="kdk-btn kdk-btn--sekundaer" href="' + geraetUrl(g, typFuer(p)) + '">Passende Alternativen für ' + esc(g.n) + '</a></p>');
        }
        ziel.innerHTML = b ? chipHtml(b) + zusatz : '';
        // passende Variante vorauswählen
        var vid = variantFuer(p, g);
        if (b && b.s === 'passt' && vid && vid !== p.var && !new URLSearchParams(location.search).get('variant')) {
          var input = document.querySelector('form[action*="/cart/add"] input[name="id"]');
          if (input && input.value !== String(vid)) {
            var u = new URL(location.href); u.searchParams.set('variant', vid); location.replace(u.toString());
          }
        }
      }
      ziel.querySelectorAll('[data-kdk-aendern-global]').forEach(function (b) {
        b.addEventListener('click', oeffneGeraetDialog);
      });
      uspPassung(p, g);
    });
  }

  // Bereich direkt unter dem Kaufen-Button für Zusatzinfos (Alternativen, „Dazu passend“)
  function nachKauf() {
    var nk = document.querySelector('.kdk-nach-kauf');
    if (nk) return nk;
    var form = document.querySelector('.product product-form, product-form');
    if (!form) return null;
    nk = document.createElement('div');
    nk.className = 'kdk-nach-kauf';
    form.insertAdjacentElement('afterend', nk);
    return nk;
  }

  // Vertrauensleiste: Passungs-Aussage auf Produktseiten an das gewählte Gerät koppeln
  function uspPassung(p, g) {
    var li = document.querySelector('[data-kdk-usp-passung]');
    if (!li) return;
    var span = li.querySelector('[data-kdk-usp-text]');
    if (!li.dataset.kdkStandard) li.dataset.kdkStandard = span.textContent;
    var b = g && p && bewerte(p, g);
    li.classList.remove('kdk-usp--passt', 'kdk-usp--pruefen', 'kdk-usp--nicht');
    if (!b) { span.textContent = li.dataset.kdkStandard; return; }
    li.classList.add('kdk-usp--' + b.s);
    span.textContent = b.s === 'passt' ? 'Passt zu deinem ' + g.n : b.s === 'nicht' ? 'Passt nicht zu deinem ' + g.n : 'Passung für ' + g.n + ' prüfen – siehe Hinweis';
  }
  function typFuer(p) {
    var t = TYPEN.filter(function (t) { return t.typen.indexOf(p.typ) > -1; })[0];
    return t ? t.id : '';
  }


  // ------------------------------------------------------------ Header
  var NEU_AB = 2026;
  var TYP_ANKER = { netzteil: 'netzteil', kabel: 'ladekabel', huelle: 'hulle', folie: 'schutzfolie', kabellos: 'kabelloses-ladegerat', auto: 'kfz-ladegerat' };
  function geraetUrl(g, typ) { return ROOT + 'pages/' + g.h + '-zubehoer' + (typ && TYP_ANKER[typ] ? '#' + TYP_ANKER[typ] : ''); }
  function nachSerie(liste) {
    var gruppen = {}, reihe = [];
    liste.forEach(function (x) { if (!gruppen[x.s]) { gruppen[x.s] = []; reihe.push(x.s); } gruppen[x.s].push(x); });
    return reihe.map(function (s) { return { serie: s, geraete: gruppen[s] }; });
  }
  function marken(daten) { var m = []; daten.geraete.forEach(function (x) { if (m.indexOf(x.m) < 0) m.push(x.m); }); return m; }
  function erkannteMarke() {
    var ua = navigator.userAgent || '';
    if (/iPhone/.test(ua)) return 'Apple';
    if (/SM-[A-Z]\d|Samsung/i.test(ua)) return 'Samsung';
    return null;
  }

  function oeffneGeraetDialog() {
    var d = document.querySelector('[data-kdk-geraet-dialog]');
    if (d && d.showModal && !d.open) d.showModal();
  }

  function initKopf(daten, g) {
    var kopf = document.querySelector('[data-kdk-kopf]');
    if (!kopf) return;
    var name = kopf.querySelector('[data-kdk-geraet-name]');
    if (name) name.textContent = g ? g.n : 'Gerät wählen';
    kopf.classList.toggle('kdk-kopf--ohne-geraet', !g);
    if (kopf.dataset.kdkBereit) return;
    kopf.dataset.kdkBereit = '1';

    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-kdk-geraet-knopf]')) { schliesseMenue(); oeffneGeraetDialog(); }
      var auf = e.target.closest('[data-kdk-geraete-menue-auf]');
      if (auf) { e.preventDefault(); umschalteGeraeteMenue(auf.closest('.kdk-nav') ? null : true); }
      else if (!e.target.closest('[data-kdk-geraete-menue]')) umschalteGeraeteMenue(false);
      if (e.target.closest('[data-kdk-menue-auf]')) oeffneMenue();
      if (e.target.closest('[data-kdk-menue-zu]')) schliesseMenue();
      var modell = e.target.closest('[data-kdk-modell]');
      if (modell) { setzeGeraet(modell.getAttribute('data-kdk-modell'), true); }
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') { umschalteGeraeteMenue(false); schliesseMenue(); } });
    var vergessen = kopf.querySelector('[data-kdk-vergessen]');
    if (vergessen) vergessen.addEventListener('click', function () { setzeGeraet(null); var d = vergessen.closest('dialog'); if (d) d.close(); });

    // Geräte-Menü (Desktop)
    var menue = kopf.querySelector('[data-kdk-geraete-menue]');
    var markenEl = kopf.querySelector('[data-kdk-marken]');
    var spalten = kopf.querySelector('[data-kdk-modelle]');
    var aktiv = (g && g.m) || erkannteMarke() || marken(daten)[0];
    function zeigeMarke(m) {
      aktiv = m;
      markenEl.innerHTML = marken(daten).map(function (x) {
        return '<button type="button" role="tab" class="kdk-chip kdk-chip--filter" aria-selected="' + (x === m) + '"' + (x === m ? ' aria-current="page"' : '') + ' data-marke="' + esc(x) + '">' + esc(x) + '</button>';
      }).join('');
      spalten.innerHTML = nachSerie(daten.geraete.filter(function (x) { return x.m === m; })).map(function (gr) {
        return '<div class="kdk-geraete-menue__spalte"><p class="kdk-label">' + esc(gr.serie) + '</p><ul role="list">' + gr.geraete.map(function (x) {
          return '<li><a href="' + geraetUrl(x) + '" data-kdk-modell="' + esc(x.h) + '">' + esc(x.n) + (x.j >= NEU_AB ? ' <span class="kdk-neu-badge">Neu</span>' : '') + '</a></li>';
        }).join('') + '</ul></div>';
      }).join('');
    }
    markenEl.addEventListener('click', function (e) { var b = e.target.closest('[data-marke]'); if (b) zeigeMarke(b.getAttribute('data-marke')); });
    zeigeMarke(aktiv);
    function umschalteGeraeteMenue(an) {
      var knopf = kopf.querySelector('.kdk-nav [data-kdk-geraete-menue-auf]');
      var offen = an == null ? menue.hidden : an;
      if (window.matchMedia('(max-width: 989px)').matches && offen) { oeffneMenue(); return; }
      menue.hidden = !offen;
      if (knopf) knopf.setAttribute('aria-expanded', String(offen));
      if (offen) menue.scrollIntoView({ block: 'nearest' });
    }

    // Mobiles Menü
    var mobil = kopf.querySelector('[data-kdk-menue]');
    var mobilGeraete = kopf.querySelector('[data-kdk-menue-geraete]');
    if (mobilGeraete) {
      mobilGeraete.innerHTML = marken(daten).map(function (m) {
        return '<details class="kdk-menue__marke"><summary>' + esc(m) + '</summary>' + nachSerie(daten.geraete.filter(function (x) { return x.m === m; })).map(function (gr) {
          return '<p class="kdk-label kdk-gedaempft">' + esc(gr.serie) + '</p><ul role="list">' + gr.geraete.map(function (x) {
            return '<li><a href="' + geraetUrl(x) + '" data-kdk-modell="' + esc(x.h) + '">' + esc(x.n) + '</a></li>';
          }).join('') + '</ul>';
        }).join('') + '</details>';
      }).join('');
    }
    function oeffneMenue() { if (!mobil) return; mobil.hidden = false; document.body.classList.add('kdk-gesperrt'); kopf.querySelector('[data-kdk-menue-auf]').setAttribute('aria-expanded', 'true'); }
    function schliesseMenue() { if (!mobil || mobil.hidden) return; mobil.hidden = true; document.body.classList.remove('kdk-gesperrt'); kopf.querySelector('[data-kdk-menue-auf]').setAttribute('aria-expanded', 'false'); }

    initSuche(kopf.querySelector('[data-kdk-suche]'), daten);
  }

  // ------------------------------------------------------------ Suche mit Gerätevorschlägen
  var TYP_WOERTER = [
    [/netzteil|ladeger|stecker|adapter|charger/, 'netzteil'], [/kabel|cable/, 'kabel'], [/h(ü|ue|u)lle|case|cover|tasche/, 'huelle'],
    [/glas|folie|panzer|display/, 'huelle'], [/auto|kfz|car/, 'auto'], [/kabellos|magsafe|induktiv|wireless/, 'kabellos']
  ];
  function norm(t) { return t.toLowerCase().replace(/galaxy|samsung|apple/g, ' ').replace(/\+/g, ' plus ').replace(/\s+/g, ' ').trim(); }
  function geraeteTreffer(daten, q) {
    var t = norm(q).split(' ').filter(function (w) { return w && !TYP_WOERTER.some(function (tw) { return tw[0].test(w); }); });
    if (!t.length) return [];
    return daten.geraete.filter(function (g) {
      var n = norm(g.n + ' ' + g.h.replace(/-/g, ' '));
      return t.every(function (w) { return (' ' + n + ' ').indexOf(' ' + w) > -1; });
    }).sort(function (a, b) { return a.n.length - b.n.length; }).slice(0, 4);
  }
  function bildUrl(p) {
    var u = p.image || (p.featured_image && p.featured_image.url);
    if (!u) return '';
    return u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=120';
  }
  function initSuche(form, daten) {
    if (!form) return;
    var input = form.querySelector('input[name="q"]');
    var box = form.querySelector('.kdk-suche__ergebnis');
    var timer = null, letzte = '';
    function zu() { box.hidden = true; input.setAttribute('aria-expanded', 'false'); }
    input.addEventListener('input', function () {
      clearTimeout(timer);
      var q = input.value.trim();
      if (q.length < 2) { zu(); return; }
      timer = setTimeout(function () { suche(q); }, 180);
    });
    input.addEventListener('focus', function () { if (box.innerHTML && input.value.trim().length > 1) { box.hidden = false; } });
    document.addEventListener('click', function (e) { if (!form.contains(e.target)) zu(); });
    form.addEventListener('keydown', function (e) {
      var items = [].slice.call(box.querySelectorAll('a'));
      if (!items.length || box.hidden) return;
      var i = items.indexOf(document.activeElement);
      if (e.key === 'ArrowDown') { e.preventDefault(); (items[i + 1] || items[0]).focus(); }
      if (e.key === 'ArrowUp') { e.preventDefault(); if (i <= 0) input.focus(); else items[i - 1].focus(); }
    });
    function suche(q) {
      letzte = q;
      var typ = '', ql = q.toLowerCase();
      TYP_WOERTER.forEach(function (tw) { if (!typ && tw[0].test(ql)) typ = tw[1]; });
      var typName = typ ? TYPEN.filter(function (t) { return t.id === typ; })[0].name : '';
      var geraete = geraeteTreffer(daten, q);
      var html = '';
      if (geraete.length) {
        html += '<p class="kdk-suche__gruppe">Passend für dein Gerät</p>' + geraete.map(function (g) {
          return '<a class="kdk-suche__geraet" role="option" href="' + geraetUrl(g, typ) + '" data-kdk-modell="' + esc(g.h) + '">' +
            '<svg viewBox="0 0 24 24" aria-hidden="true"><rect x="6.5" y="2.5" width="11" height="19" rx="2.5"/></svg>' +
            '<span><strong>' + esc(typName || 'Zubehör') + ' für ' + esc(g.n) + '</strong><small>' + treffer(daten, g, typ).length + ' passende Produkte</small></span></a>';
        }).join('');
      }
      box.innerHTML = html + '<p class="kdk-suche__gruppe">Produkte</p><p class="kdk-suche__laedt">Suche …</p>';
      box.hidden = false; input.setAttribute('aria-expanded', 'true');
      fetch(ROOT + 'search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product,collection&resources[limit]=6&resources[options][fields]=title,product_type,variants.title,vendor')
        .then(function (r) { return r.json(); })
        .then(function (d) {
          if (letzte !== q) return;
          var res = d.resources && d.resources.results || {};
          var g = aktuellesGeraet(daten);
          var prod = (res.products || []).map(function (p) {
            var pd = daten.pIndex[p.handle];
            var b = g && pd ? bewerte(pd, g) : null;
            return '<a class="kdk-suche__produkt" role="option" href="' + esc(p.url) + '">' +
              (bildUrl(p) ? '<img src="' + esc(bildUrl(p)) + '" alt="" width="56" height="56" loading="lazy">' : '<span></span>') +
              '<span><strong>' + esc(p.title) + '</strong><small>' + preis(Math.round(parseFloat(p.price) * 100)) +
              (b ? ' · <span class="kdk-suche__status kdk-suche__status--' + b.s + '">' + (b.s === 'passt' ? 'passt' : b.s === 'pruefen' ? 'bitte prüfen' : 'passt nicht') + '</span>' : '') + '</small></span></a>';
          }).join('');
          var koll = (res.collections || []).slice(0, 3).map(function (c) { return '<a class="kdk-suche__koll" role="option" href="' + esc(c.url) + '">' + esc(c.title) + '</a>'; }).join('');
          box.innerHTML = html + (prod ? '<p class="kdk-suche__gruppe">Produkte</p>' + prod : '') + (koll ? '<p class="kdk-suche__gruppe">Kategorien</p>' + koll : '') +
            '<a class="kdk-suche__alle" href="' + ROOT + 'search?q=' + encodeURIComponent(q) + '&options[prefix]=last">Alle Ergebnisse für „' + esc(q) + '“</a>';
        }).catch(function () { /* Suche bleibt per Enter nutzbar */ });
    }
  }


  // ------------------------------------------------------------ Startseite
  function initWahl(daten, g) {
    var el = document.querySelector('[data-kdk-wahl]');
    if (!el || el.dataset.kdkBereit) return;
    el.dataset.kdkBereit = '1';
    var chips = el.querySelector('[data-kdk-wahl-chips]');
    var alle = el.querySelector('[data-kdk-wahl-alle]');
    var bereich = el.querySelector('[data-kdk-wahl-modelle]');
    function zeige(m) {
      el.querySelectorAll('[data-marke]').forEach(function (b) { b.setAttribute('aria-pressed', String(b.getAttribute('data-marke') === m)); });
      var liste = daten.geraete.filter(function (x) { return x.m === m; });
      var serien = nachSerie(liste).slice(0, 3);
      chips.innerHTML = serien.map(function (gr) {
        return '<div class="kdk-wahl__serie"><span class="kdk-gedaempft">' + esc(gr.serie) + '</span>' + gr.geraete.map(function (x) {
          return '<a class="kdk-chip kdk-chip--filter' + (g && g.h === x.h ? ' kdk-chip--aktiv' : '') + '" href="' + geraetUrl(x) + '" data-kdk-modell="' + esc(x.h) + '">' + esc(x.n.replace(/^(iPhone|Galaxy) /, '')) + '</a>';
        }).join('') + '</div>';
      }).join('');
      alle.innerHTML = '<option value="">Alle ' + esc(m) + '-Modelle</option>' + nachSerie(liste).map(function (gr) {
        return '<optgroup label="' + esc(gr.serie) + '">' + gr.geraete.map(function (x) { return '<option value="' + esc(x.h) + '">' + esc(x.n) + '</option>'; }).join('') + '</optgroup>';
      }).join('');
      bereich.hidden = false;
    }
    el.querySelectorAll('[data-marke]').forEach(function (b) { b.addEventListener('click', function () { zeige(b.getAttribute('data-marke')); }); });
    alle.addEventListener('change', function () { if (alle.value) { setzeGeraet(alle.value, true); location.href = geraetUrl(daten.gIndex[alle.value]); } });
    var erkannt = erkannteMarke();
    var hinweis = el.querySelector('[data-kdk-erkannt]');
    if (g) { hinweis.innerHTML = 'Dein Gerät: <strong>' + esc(g.n) + '</strong> – <a href="' + geraetUrl(g) + '">alles Passende ansehen</a>'; hinweis.hidden = false; zeige(g.m); }
    else if (erkannt) { hinweis.innerHTML = 'Wir haben ein <strong>' + (erkannt === 'Apple' ? 'iPhone' : 'Samsung Galaxy') + '</strong> erkannt. Welches Modell hast du?'; hinweis.hidden = false; zeige(erkannt); }
  }

  // Kollektions-Reihen: mit Gerät passende Produkte nach vorn, unpassende ausblenden
  function initKollReihen(daten, g) {
    document.querySelectorAll('[data-kdk-koll-reihe]').forEach(function (ul) {
      var n = Number(ul.getAttribute('data-anzahl')) || 8;
      var li = [].slice.call(ul.children);
      if (!ul.dataset.kdkReihenfolge) ul.dataset.kdkReihenfolge = '1', li.forEach(function (x, i) { x.dataset.kdkPos = i; });
      li.sort(function (a, b) { return a.dataset.kdkPos - b.dataset.kdkPos; });
      var wert = function (x) {
        if (!g) return 1;
        var b = bewerte(daten.pIndex[x.querySelector('[data-kdk-handle]').getAttribute('data-kdk-handle')], g);
        return !b ? 1 : b.s === 'passt' ? 0 : b.s === 'pruefen' ? 1 : 3;
      };
      li.sort(function (a, b) { return (wert(a) - wert(b)) || (a.dataset.kdkPos - b.dataset.kdkPos); });
      var sichtbar = 0;
      li.forEach(function (x) { ul.appendChild(x); var w = wert(x); x.hidden = !(w < 3 && sichtbar < n); if (!x.hidden) sichtbar++; });
    });
  }

  function initKacheln(daten) {
    document.querySelectorAll('[data-kdk-kachel-geraet]').forEach(function (k) {
      var g = daten.gIndex[k.getAttribute('data-kdk-kachel-geraet')];
      var z = k.querySelector('[data-kdk-kachel-anzahl]');
      if (!g || !z) return;
      z.textContent = treffer(daten, g, '').length + ' passende Produkte';
      if (!k.getAttribute('href') || k.getAttribute('href') === '#') k.setAttribute('href', geraetUrl(g));
      k.setAttribute('data-kdk-modell', g.h);
    });
  }

  function initNeu(daten) {
    document.querySelectorAll('[data-kdk-neu]').forEach(function (el) {
      var ab = Number(el.getAttribute('data-ab')) || NEU_AB;
      var liste = daten.geraete.filter(function (x) { return x.j >= ab; });
      el.innerHTML = liste.map(function (x) {
        return '<a class="kdk-neu__geraet" href="' + geraetUrl(x) + '" data-kdk-modell="' + esc(x.h) + '">' +
          '<svg viewBox="0 0 24 24" aria-hidden="true"><rect x="6.5" y="2.5" width="11" height="19" rx="2.5"/><path d="M11 18.5h2"/></svg>' +
          '<span><small>' + esc(x.m) + '</small><strong>' + esc(x.n) + '</strong></span></a>';
      }).join('');
    });
  }

  function mischung(liste, n) {
    // abwechselnd aus jeder Produktart, damit eine Reihe nicht nur Hüllen zeigt
    var nachTyp = {};
    liste.forEach(function (x) { var t = typFuer(x.p) || 'x'; (nachTyp[t] = nachTyp[t] || []).push(x); });
    var aus = [], typen = Object.keys(nachTyp);
    while (aus.length < n && typen.some(function (t) { return nachTyp[t].length; })) {
      typen.forEach(function (t) { if (aus.length < n && nachTyp[t].length) aus.push(nachTyp[t].shift()); });
    }
    return aus;
  }
  function initReihen(daten) {
    document.querySelectorAll('[data-kdk-reihe]').forEach(function (el) {
      var g = daten.gIndex[el.getAttribute('data-geraet')];
      var ziel = el.querySelector('[data-kdk-reihe-liste]');
      if (!g) { el.hidden = true; return; }
      var liste = treffer(daten, g, '').filter(function (x) { return x.p.ok && x.b.s === 'passt'; });
      liste.sort(function (a, b) { return (b.p.o - a.p.o) || (a.p.p - b.p.p); });
      ziel.innerHTML = mischung(liste, Number(el.getAttribute('data-anzahl')) || 8).map(function (x) { return '<li>' + karteHtml(x.p, x.b, g, daten) + '</li>'; }).join('');
    });
  }

  var SPEICHER_ZULETZT = 'kdk-zuletzt';
  function merkeProdukt() {
    var el = document.querySelector('[data-kdk-produkt]');
    if (!el) return;
    var h = el.getAttribute('data-kdk-produkt');
    var l = [];
    try { l = JSON.parse(lies(SPEICHER_ZULETZT) || '[]'); } catch (e) { l = []; }
    l = [h].concat(l.filter(function (x) { return x !== h; })).slice(0, 12);
    schreib(SPEICHER_ZULETZT, JSON.stringify(l));
  }
  function initZuletzt(daten, g) {
    var el = document.querySelector('[data-kdk-zuletzt]');
    if (!el) return;
    var l = [];
    try { l = JSON.parse(lies(SPEICHER_ZULETZT) || '[]'); } catch (e) { l = []; }
    var aktuell = (document.querySelector('[data-kdk-produkt]') || {}).getAttribute;
    var eigen = aktuell ? document.querySelector('[data-kdk-produkt]').getAttribute('data-kdk-produkt') : null;
    var p = l.filter(function (h) { return h !== eigen && daten.pIndex[h]; }).slice(0, 4).map(function (h) { return daten.pIndex[h]; });
    if (!p.length) return;
    el.querySelector('[data-kdk-zuletzt-liste]').innerHTML = p.map(function (x) { return '<li>' + karteHtml(x, g ? bewerte(x, g) : null, g, daten) + '</li>'; }).join('');
    el.hidden = false;
  }


  // ------------------------------------------------------------ Produktseite: „Passt dazu“ + Kaufleiste
  function ergaenzungen(daten, p, g) {
    var geraete = g ? [g.h] : (p.g || []);
    var lieferbar = function (x) { return x.ok && x.h !== p.h; };
    var guenstig = function (a, b) { return (b.o - a.o) || (a.p - b.p); };
    var aus = [];
    if (p.typ === 'Hülle' && geraete.length) {
      aus = daten.produkte.filter(function (x) { return lieferbar(x) && x.typ === 'Netzteil' && !x.kd && (x.aus || []).indexOf('USB-C') > -1 && (x.w || 0) >= 20; });
    } else if ((p.typ === 'Netzteil' || p.typ === 'Kfz-Ladegerät') && !p.kd) {
      var port = (p.aus || []).indexOf('USB-C') > -1 ? 'USB-C' : (p.aus || [])[0];
      aus = daten.produkte.filter(function (x) { return lieferbar(x) && x.typ === 'Ladekabel' && x.a === port && (!g || x.b === g.a); });
    } else if (p.typ === 'Ladekabel' && p.a) {
      aus = daten.produkte.filter(function (x) {
        return lieferbar(x) && x.typ === 'Netzteil' && (x.aus || []).indexOf(p.a) > -1 && !x.kd && (!g || (bewerte(x, g) || {}).s === 'passt');
      });
    }
    return aus.sort(guenstig).slice(0, 2);
  }

  function initDazu(daten, g) {
    var el = document.querySelector('[data-kdk-produkt]');
    if (!el || el.dataset.kdkDazu) return;
    var p = daten.pIndex[el.getAttribute('data-kdk-produkt')];
    if (!p) return;
    var b0 = g ? bewerte(p, g) : null;
    if (b0 && b0.s === 'nicht') return;
    var liste = ergaenzungen(daten, p, g);
    if (!liste.length) return;
    el.dataset.kdkDazu = '1';
    var titel = { 'Hülle': 'Dazu passend: Schnell-Ladegerät', 'Netzteil': 'Dazu brauchst du: Ladekabel', 'Kfz-Ladegerät': 'Dazu brauchst du: Ladekabel', 'Ladekabel': 'Dazu passend: Netzteil' }[p.typ];
    var box = document.createElement('div');
    box.className = 'kdk-dazu';
    box.innerHTML = '<p class="kdk-dazu__titel">' + esc(titel) + '</p>' + liste.map(function (x) {
      var vid = variantFuer(x, g);
      return '<div class="kdk-dazu__produkt">' + (x.img ? '<img src="' + esc(x.img) + '" alt="" width="64" height="64" loading="lazy">' : '') +
        '<span class="kdk-dazu__text"><a href="' + esc(x.u) + '">' + esc(x.t) + '</a><span>' + (technik(x) ? esc(technik(x)) + ' · ' : '') + '<strong>' + preis(x.p) + '</strong></span></span>' +
        '<button type="button" class="kdk-btn kdk-btn--sekundaer kdk-dazu__knopf" data-kdk-dazu-variante="' + vid + '">Beides in den Warenkorb</button></div>';
    }).join('');
    (nachKauf() || el).appendChild(box);
    box.addEventListener('click', function (e) {
      var b = e.target.closest('[data-kdk-dazu-variante]');
      if (!b) return;
      var form = document.querySelector('form[action*="/cart/add"] input[name="id"]');
      var items = [{ id: Number(b.getAttribute('data-kdk-dazu-variante')), quantity: 1 }];
      if (form && form.value) items.unshift({ id: Number(form.value), quantity: 1 });
      b.disabled = true; b.textContent = 'Wird hinzugefügt …';
      fetch(ROOT + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: items }) })
        .then(function (r) { if (!r.ok) throw new Error(); location.href = ROOT + 'cart'; })
        .catch(function () { b.disabled = false; b.textContent = 'Nicht verfügbar – bitte einzeln kaufen'; });
    });
  }

  function initKaufleiste() {
    var knopf = document.querySelector('.product-form__submit');
    if (!knopf || document.querySelector('.kdk-kaufleiste')) return;
    var titel = (document.querySelector('.product__title h1') || {}).textContent || '';
    var leiste = document.createElement('div');
    leiste.className = 'kdk-kaufleiste';
    leiste.hidden = true;
    leiste.innerHTML = '<span class="kdk-kaufleiste__text"><span class="kdk-kaufleiste__titel"></span><strong class="kdk-kaufleiste__preis"></strong></span>' +
      '<button type="button" class="kdk-btn kdk-btn--primaer">In den Warenkorb</button>';
    leiste.querySelector('.kdk-kaufleiste__titel').textContent = titel.trim();
    document.body.appendChild(leiste);
    function preisAktualisieren() {
      var pr = document.querySelector('.product .price-item--sale, .product .price-item--regular');
      leiste.querySelector('.kdk-kaufleiste__preis').textContent = pr ? pr.textContent.trim() : '';
    }
    leiste.querySelector('button').addEventListener('click', function () { if (!knopf.disabled) knopf.click(); });
    var wartet = false;
    function pruefen() {
      wartet = false;
      var r = knopf.getBoundingClientRect();
      var weg = r.bottom < 0 || r.top > window.innerHeight; // Knopf nicht im Bild (oben raus oder noch unten)
      if (weg) preisAktualisieren();
      leiste.hidden = !weg || knopf.disabled;
      document.documentElement.classList.toggle('kdk-leiste-an', !leiste.hidden);
    }
    window.addEventListener('scroll', function () { if (!wartet) { wartet = true; requestAnimationFrame(pruefen); } }, { passive: true });
    pruefen();
  }


  // ------------------------------------------------------------ Widerrufsbutton (Pflicht seit 19.06.2026): zusätzlich als Link im Footer
  function initWiderruf(versuch) {
    var knopf = document.getElementById('wb-trigger-btn');
    if (!knopf) { if ((versuch || 0) < 20) setTimeout(function () { initWiderruf((versuch || 0) + 1); }, 500); return; }
    var fuss = document.querySelector('footer .footer__content-bottom-wrapper, footer .footer__content-bottom, footer');
    if (!fuss || fuss.querySelector('.kdk-widerruf-link')) return;
    var b = document.createElement('button');
    b.type = 'button'; b.className = 'kdk-widerruf-link'; b.textContent = 'Vertrag widerrufen';
    b.addEventListener('click', function () { knopf.click(); });
    fuss.appendChild(b);
  }


  // ------------------------------------------------------------ Mengenrabatt: kompakte Auswahl statt App-Widget
  // Stufen kommen aus dem Block „kdk_menge“ (z. B. „2:5,3:7,4:10“). Berechnet wird der Rabatt weiterhin im Warenkorb.
  function initMenge() {
    var el = document.querySelector('[data-kdk-menge]');
    if (!el || el.dataset.kdkBereit) return;
    var input = document.querySelector('.product quantity-input input[name="quantity"], quantity-input input[name="quantity"]');
    if (!input) return;
    el.dataset.kdkBereit = '1';
    var stufen = (el.getAttribute('data-kdk-menge') || '').split(',').map(function (s) {
      var x = s.split(':'); return { ab: parseInt(x[0], 10), pz: parseFloat(x[1]) };
    }).filter(function (s) { return s.ab > 1 && s.pz > 0; }).sort(function (a, b) { return a.ab - b.ab; });
    if (!stufen.length) return;
    var hoechste = stufen[stufen.length - 1].ab;
    var chips = [{ ab: 1, pz: 0 }].concat(stufen);
    el.innerHTML = '<div class="kdk-menge__chips" role="radiogroup" aria-label="Menge – mehr kaufen, mehr sparen">' + chips.map(function (s) {
      var label = (s.ab === hoechste ? 'ab ' : '') + s.ab + ' Stück';
      return '<button type="button" class="kdk-menge__chip" role="radio" aria-checked="false" data-ab="' + s.ab + '"><span>' + label + '</span>' +
        (s.pz ? '<small>−' + String(s.pz).replace('.', ',') + ' %</small>' : '<small>Einzelpreis</small>') + '</button>';
    }).join('') + '</div><p class="kdk-menge__summe" aria-live="polite"></p>';
    var qtyBlock = input.closest('.product-form__quantity');
    function einzelpreis() {
      var pr = document.querySelector('.product .price__sale .price-item--sale, .product .price-item--regular');
      var m = pr && pr.textContent.replace(/[^0-9,]/g, '').replace(',', '.');
      return m ? Math.round(parseFloat(m) * 100) : 0;
    }
    function stufeFuer(n) { var s = null; stufen.forEach(function (x) { if (n >= x.ab) s = x; }); return s; }
    function zeigen() {
      var n = Math.max(1, parseInt(input.value, 10) || 1);
      var aktiv = n >= hoechste ? hoechste : n;
      el.querySelectorAll('.kdk-menge__chip').forEach(function (c) {
        var an = Number(c.getAttribute('data-ab')) === aktiv;
        c.classList.toggle('is-aktiv', an); c.setAttribute('aria-checked', an ? 'true' : 'false');
      });
      if (qtyBlock) qtyBlock.classList.toggle('kdk-menge-aus', n < hoechste);
      var ep = einzelpreis(), s = stufeFuer(n), summe = el.querySelector('.kdk-menge__summe');
      if (!ep || n < 2) { summe.textContent = ''; summe.hidden = true; return; }
      summe.hidden = false;
      // wie im Warenkorb: Rabatt pro Stück abgerundet
      var voll = ep * n, rabatt = s ? voll - Math.floor(ep * s.pz / 100 + 1e-9) * n : voll;
      summe.innerHTML = n + ' × = <strong>' + preis(rabatt) + '</strong>' + (s ? ' <s>' + preis(voll) + '</s> <span class="kdk-menge__spar">du sparst ' + preis(voll - rabatt) + '</span>' : '');
    }
    el.addEventListener('click', function (e) {
      var c = e.target.closest('.kdk-menge__chip');
      if (!c) return;
      input.value = c.getAttribute('data-ab');
      input.dispatchEvent(new Event('change', { bubbles: true }));
      zeigen();
    });
    ['change', 'input'].forEach(function (ev) { input.addEventListener(ev, zeigen); });
    document.addEventListener('click', function (e) { if (e.target.closest('quantity-input button')) setTimeout(zeigen, 0); });
    var preisEl = document.querySelector('.product [id^="price-"]');
    if (preisEl && window.MutationObserver) new MutationObserver(zeigen).observe(preisEl, { childList: true, subtree: true, characterData: true });
    zeigen();
  }


  // ------------------------------------------------------------ Newsletter: Gerät als Kunden-Tag mitsenden
  function initNewsletter(daten, g) {
    document.querySelectorAll('input[name="contact[tags]"]').forEach(function (feld) {
      if (!/newsletter/.test(feld.value)) return;
      var basis = feld.getAttribute('data-kdk-basis') || feld.value;
      feld.setAttribute('data-kdk-basis', basis);
      feld.value = g ? basis + ',geraet-' + g.h + ',hersteller-' + g.m.toLowerCase() : basis;
      var sektion = feld.closest('.newsletter, .shopify-section');
      var titel = sektion && sektion.querySelector('.newsletter__wrapper h2, h2');
      if (titel && g) titel.textContent = 'Neues Zubehör für dein ' + g.n;
    });
  }

  // ------------------------------------------------------------ Start
  function startAppBadges() {
    appBadgesDeutsch();
    if (!window.MutationObserver) return;
    var wartet = false;
    new MutationObserver(function () {
      if (wartet) return;
      wartet = true;
      requestAnimationFrame(function () { wartet = false; appBadgesDeutsch(); });
    }).observe(document.body, { childList: true, subtree: true });
  }

  function start() {
    startAppBadges();
    initKaufleiste();
    initMenge();
    initWiderruf();
    merkeProdukt();
    ladeDaten().then(function (daten) {
      if (!daten.geraete.length) return;
      document.documentElement.classList.add('kdk-bereit');
      function alles() {
        var g = aktuellesGeraet(daten);
        chipsAufKarten(daten, g);
        initFinder(daten, g);
        initKopf(daten, g);
        initWahl(daten, g);
        initNeu(daten);
        initKacheln(daten);
        initKollReihen(daten, g);
        initReihen(daten);
        initZuletzt(daten, g);
        initErgebnis(daten, g);
        initProdukt(daten, g);
        initDazu(daten, g);
        initNewsletter(daten, g);
      }
      alles();
      document.addEventListener('kdk:geraet', function (e) {
        if (e.detail && e.detail.navigiert) return;
        if (document.querySelector('[data-kdk-ergebnis]')) {
          var u = new URL(location.href); u.searchParams.delete('geraet'); var h = lies(SPEICHER_GERAET);
          if (h) u.searchParams.set('geraet', h); location.href = u.toString(); return;
        }
        alles();
      });
      document.addEventListener('change', function (e) {
        if (e.target.matches('[data-kdk-filterleiste] input')) chipsAufKarten(daten, aktuellesGeraet(daten));
      });
      // Dawn lädt das Produktraster nach Filtern/Sortieren neu
      var raster = document.getElementById('ProductGridContainer');
      if (raster && window.MutationObserver) {
        new MutationObserver(function () { chipsAufKarten(daten, aktuellesGeraet(daten)); }).observe(raster, { childList: true });
      }
    });
  }

  window.kdk = { bewerte: bewerte, ladeDaten: ladeDaten, setzeGeraet: setzeGeraet };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
